<div class="main-banner video-container">
    <video id="background-video" preload="auto">
        <source src="current_video_placeholder" type="video/mp4">
        <!-- You can add additional source elements for other video formats (e.g., WebM, Ogg) -->
    </video>
    <div class="container-fluid">
        <div class="row">
            <img src="https://imgvid.blob.core.windows.net/imgvid/home_banner.png" alt="image" style="width:50%; margin: auto; margin-bottom: 60px; margin-top: -120px; opacity: 80%">
        </div>
        <div class="row">
            <div class="col-lg-2 col-md-6"></div>
            <div class="col-lg-8 col-md-12">
                <div class="main-banner-content" *ngFor="let Content of mainBannerContent;">
                    <h1 class="wow animate__animated animate__fadeInLeft" data-wow-delay="00ms" data-wow-duration="1000ms">{{Content.title}}</h1>
                    <!-- <p class="wow animate__animated animate__fadeInLeft" data-wow-delay="100ms" data-wow-duration="1000ms">{{Content.paragraphText}}</p> -->
                    <!-- <div class="btn-box">
                        <a href="{{Content.videoBtnLink}}" class="video-btn wow animate__animated animate__fadeInLeft popup-youtube" data-wow-delay="300ms" data-wow-duration="1000ms"><i class="{{Content.videoBtnIcon}}"></i> {{Content.videoBtnText}}</a>
                    </div> -->
                    <!-- <br/> -->
                </div>
            </div>
            <!-- <div class="col-lg-2 col-md-6"></div> -->

            <div>
                <video preload="auto" style="display: none"><source src="https://imgvid.blob.core.windows.net/imgvid/bg_video.mp4" type="video/mp4"></video>
            </div>
        </div>
    </div>
</div>